module.exports = __webpack_public_path__ + "img/game-carousel-1.ad682770.png";